import { Schema } from "effect";
import { CommutePreference, FedClearanceType, PayRate, PlacementType, Salary, ScheduleType, SecurityClearance, Shift, WorkplaceType, YesNoUnknown, } from "./TalentMeetingDetails.js";
import { ACTIVITY_TYPES } from "@aglocal/types";
export const AdditionalDetails = Schema.Struct({
    securityClearance: SecurityClearance,
    fedClearanceType: FedClearanceType,
    dateAvailable: Schema.String,
    desiredPlacementType: Schema.Array(PlacementType),
    desiredSchedule: ScheduleType,
    desiredWorkplaceType: Schema.Array(WorkplaceType),
    desiredShift: Schema.Array(Shift),
    desiredPayRate: PayRate,
    desiredSalary: Salary,
    willingToRelocate: YesNoUnknown,
    nationalOpportunities: YesNoUnknown,
    reliableTransportation: YesNoUnknown,
    commutePreference: CommutePreference,
});
/**
 * The wrap-up summary together with the model that generated it. `name` and
 * `settings` are absent when the summary was loaded from Salesforce instead of
 * being generated in this session.
 */
export const PostMeetingSummary = Schema.Struct({
    value: Schema.String,
    name: Schema.optional(Schema.String),
    settings: Schema.optional(Schema.Struct({
        model: Schema.optional(Schema.String),
        pattern: Schema.optional(Schema.Literal("MAP_REDUCE", "REFINE", "STUFF")),
    })),
});
export const PostMeetingForm = Schema.Struct({
    // Hidden Fields
    id: Schema.String,
    // Form Fields
    meetingType: Schema.Literal(...ACTIVITY_TYPES),
    jobTitle: Schema.String.pipe(Schema.nonEmptyString({ message: () => "Please enter a job title" })),
    currentCompany: Schema.String,
    notes: Schema.String,
    summary: PostMeetingSummary,
    skills: Schema.Array(Schema.String),
    skillsComments: Schema.String,
    goalsAndInterests: Schema.String,
    locationComments: Schema.String,
    negativeSkills: Schema.Array(Schema.String),
    // Additional Details
    additionalDetails: Schema.partial(AdditionalDetails),
});
